<template>
  <div v-observe-visibility="visibilityChanged">

    <!--DELETE - Dialog-->
    <v-dialog
      persistent
      v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Calculation</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
            <v-checkbox
              :rules="[v => !!v || 'You have to check this to continue!']"
              required
              v-model="deleteChecked" color="primary"
              label="Do you really want to delete this calculation?"/>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
          <v-btn color="primary darken-1" flat @click.native="deleteCalculation(selectedCalculationData)">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Activate/Deactivate - Dialog-->
    <v-dialog
      persistent
      v-model="activateDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span
            class="headline">{{selectedCalculationData.active === true? 'Deactivate' : 'Activate'}} Calculation</span>
        </v-card-title>

        <v-card-text>
          Do you really want to {{selectedCalculationData.active === true? 'deactivate' : 'activate'}} this calculation?
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" flat @click.native="cancelActivateDialog()">CANCEL</v-btn>
          <v-btn :loading="activationLoading" color="primary darken-1" flat
                 @click.native="activateCalculation(selectedCalculationData)">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-layout row wrap>

      <v-flex xs12 sm12 pr-4 pt-4 pl-4>

        <v-btn class="secondary white--text" @click.native="openCalculateDialog()">
          New Price Calculation
          <v-icon class="white--text" right>add</v-icon>
        </v-btn>

      </v-flex>

    </v-layout>

    <v-layout id="table-container" row>
      <v-flex xs12 pr-4 pt-4 pl-4>
        <v-card>
          <v-card-title>
            Price Calculations
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            />
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="getItems"
            :pagination.sync="pagination"
            :total-items=total
            class="elevation-0 offer-table"
            :loading="loading"
            :rows-per-page-items="rowsPageItems"
          >

            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                {{ props.header.text }}
                </span>
                <span>
                {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <tr @dblclick="openCalculateDialog(props.item.id)">
                <td>{{ props.item.id }}</td>
                <td class="text-xs-left">{{ props.item.product.manufacturer.name }}</td>
                <td class="text-xs-left">{{ props.item.product.reference }}</td>
                <td class="text-xs-left">{{ props.item.quantity }}</td>
                <td class="text-xs-left">{{ props.item.unit.code }}</td>
                <td class="text-xs-right">{{props.item.unit_sales_price | toMoney }} {{props.item.currency.name}}</td>
                <td class="text-xs-right">{{props.item.total_sales_price | toMoney }} {{props.item.currency.name}}</td>
                <td class="text-xs-right">

                  <v-icon size="20" color="secondary"
                          class="ma-1"
                          @click="openCalculateDialog(props.item.id)"
                  >
                    fa-calculator
                  </v-icon>

                  <v-icon color="red"
                          class="ma-1"
                          @click="deletePositionDialog(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
                <td class="text-xs-right">
                  <v-checkbox
                    @click="activatePositionDialog(props.item)"
                    label=""
                    dense
                    :input-value="props.item.active"
                    primary
                    hide-details
                  />
                </td>
              </tr>
            </template>
          </v-data-table>

        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-end mr-5>

      <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>


      </v-flex>

    </v-layout>
    <!--CalculateDialog-->
    <calculateDialog v-if="renderCalculateDialog"/>

  </div>
</template>

<script>
  import {
    Settings,
    OfferPosition,
    ManufacturersSettings,
    ProductSettings,
    VatSettings,
    ProductListings
  } from '../../../store/namespace-helper'

  import calculateDialog from './ProductListingsPriceCalculationDialog.vue'
  import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'
  import {numberFormatFilters} from '../../../mixins/numberFormatFilters'

  import _ from 'lodash'

  export default {
    name: 'ProductListingsPriceCalculations',
    mixins: [comboAutoCompleteFiltersMixin, numberFormatFilters],
    components: {
      calculateDialog
    },
    data () {
      return {
        isVisible: false,
        hide: true,
        activeTab: 0,
        headers: [
          {text: 'Calculation-ID', value: 'id'},
          {text: 'Manufacturer', value: 'manufacturers_id'},
          {text: 'Reference', value: 'reference'},
          {text: 'Quantity', value: 'quantity'},
          {text: 'Unit', value: 'unit_id', sortable: false},
          {text: 'Unit Sales Price', value: 'unit_sales_price', sortable: false, align: 'right'},
          {text: 'Total Sales Price', value: 'total_sales_price', sortable: false, align: 'right'},
          {text: 'Actions', value: '', sortable: false, align: 'right'},
          {text: 'Active', value: '', sortable: false, align: 'right'}
        ],
        pagination: {},
        search: '',
        total: 0,
        onDismissed: false,
        rowsPageItems: [{'text': 'All', 'value': -1}],
        selectedSuppliers: null,
        chipsDeletable: true,
        addDialog: false,
        deleteDialog: false,
        activateDialog: false,
        deleteChecked: false,
        deleteFormValidation: false,
        rules: {
          required: value => !!value || 'Required.',
          descriptionCounter: value => value.length <= 500 || 'Max 500 characters',
          numberCounter: value => value.length <= 255 || 'Max 255 characters'
        },
        creatingRequestsErrorMsg: '',
        squareFlag: false,
        renderCalculateDialog: false,
        selectedCalculationData: {
          active: false
        },
        activationLoading: false

      }
    },
    mounted () {

    },
    methods: {
      visibilityChanged (isVisible, entry) {
        if (this.isVisible !== isVisible) {
          this.isVisible = isVisible
          if (isVisible) {
            console.log('tab visible, load data')
            this.loadItems()
            this.loadManufacturers()
            this.loadUnits()
            this.loadProducts()
          } else {

          }
        }
      },
      loadItems: function () {
        const {sortBy, descending, page, rowsPerPage} = this.pagination
        const query = {
          id: this.getSelectedProduct.id,
          sortBy: sortBy || 'id',
          descending: descending ? 'desc' : 'asc',
          page: page || 1,
          limit: rowsPerPage !== -1 ? rowsPerPage : 0,
          search: this.search ? this.search : ''
        }
        this.$store.dispatch(ProductListings.actions.loadPriceCalculations, query)
      },
      loadManufacturers () {
        this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
      },
      loadUnits () {
        this.$store.dispatch(Settings.actions.loadAllUnits)
      },
      loadSuppliers (manufacturersId) {
        console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
        this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
      },
      loadProducts () {
        this.$store.dispatch(ProductSettings.actions.loadAllProducts)
      },
      loadVats () {
        this.$store.dispatch(VatSettings.actions.loadAllVats)
      },
      openNewPositionDialog (val) {
        let item = this.getItems.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, item)
        }
        this.addDialog = true
      },
      getManufacturerName (val) {
        let item = this.getProducts.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          if (item.manufacturer !== null && typeof item.manufacturer !== 'undefined') {
            return item.manufacturer.name
          }
        }
        return ''
      },
      deleteCalculation (item) {
        if (!this.$refs.form.validate()) {
          return
        }

        this.deleteDialog = false
        this.deleteChecked = false

        /*          this.$store.dispatch(OfferPosition.actions.deleteInquiriesPositions, requestData) */
      },
      activateCalculation (item) {
        this.activationLoading = true
        this.$store.dispatch(ProductListings.actions.setActiveCalculationState, this.selectedCalculationData).then(response => {
          this.activateDialog = false
          this.activationLoading = false
          this.loadItems()
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.activateDialog = false
          this.activationLoading = false
          this.loadItems()
        })
      },
      deletePositionDialog (item) {
        this.selectedCalculationData = _.cloneDeep(item)
        this.deleteDialog = true
      },
      activatePositionDialog (item) {
        this.selectedCalculationData = item
        this.activateDialog = true
      },
      cancelDeleteDialog () {
        this.deleteDialog = false
        this.$refs.form.reset()
      },
      cancelActivateDialog () {
        this.activateDialog = false
      },
      openCalculateDialog (val) {
        let item = this.getItems.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          this.$store.dispatch(ProductListings.actions.setSelectedPriceCalculation, item)
        } else {
          this.$store.dispatch(ProductListings.actions.setSelectedPriceCalculation, {
            id: 0,
            products_id: this.getSelectedProduct.id,
            units_id: 28,
            product: this.getSelectedProduct,
            currencies_id: 1,
            currency: {
              id: 1,
              name: 'EUR'
            },
            products_listings_price_calculations_additional_costs: [],
            products_listings_price_calculations_discounts: [],
            delivery_time: {
              id: 0
            },
            margin: 0.80,
            unit: {
              code: 'PCS'
            }
          })
        }
        this.renderCalculateDialog = true
        setTimeout(() => {
          this.$store.dispatch(ProductListings.actions.openClosePriceCalculationDialog)
        }, 200)
      },
      throttledLoadItems: _.debounce(function () {
        this.loadItems()
      }, 450),
      throttledTranslate: _.debounce(function (q, target) {
        this.translate(q, target)
      }, 450)

    },
    computed: {
      getItems () {
        this.total = this.$store.getters[ProductListings.getters.priceCalculations].length
        return this.$store.getters[ProductListings.getters.priceCalculations]
      },
      getSuppliers () {
        return this.$store.getters[Settings.getters.getManufacturerSuppliers]
      },
      getSelectedProduct () {
        return this.$store.getters[ProductSettings.getters.getSelectedProduct]
      },
      getManufacturers () {
        return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
      },
      getProducts () {
        return this.$store.getters[ProductSettings.getters.getAllProducts]
      },
      getUnits () {
        return this.$store.getters[Settings.getters.getAllUnits]
      },
      loading () {
        return this.$store.getters[Settings.getters.loading]
      },
      descriptionRules () {
        return [this.rules.descriptionCounter]
      },
      numberRules () {
        return [this.rules.numberCounter]
      },
      calculateDialogState () {
        return this.$store.getters[ProductListings.getters.getCalculationDialogState]
      }
    },
    watch: {
      pagination: {
        handler () {
          this.loadItems()
        },
        deep: true
      },
      calculateDialogState: {
        handler (val) {
          if (!val) {
            setTimeout(() => {
              this.renderCalculateDialog = false
            }, 850)
            this.loadItems()
          }
        },
        deep: true
      },
      search: {
        handler (val) {
          this.throttledLoadItems()
        },
        deep: true
      }
    }

  }
</script>

<style scoped>

  th:focus {
    outline: none !important;
  }

  .v-input.v-input--selection-controls.v-input--checkbox.v-input--hide-details.theme--light {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProductListings/ProductListingsPriceCalculations/ProductListingsPriceCalculations.vue